export default __webpack_public_path__ + "static/media/Collars-Edit-1.6caa24f9.jpg";